module.exports = __webpack_public_path__ + "media/truth_initiative_two/heavy-metal-title@2x_1500x600-b10ff9d8.png";